import useTranslationsBase, { TranslateFunction } from '~/components/translation/use-translations';

type TextKeys = readonly string[];

export type Translations<T extends TextKeys> = Record<T[number], string>;

interface ReturnValue<T extends TextKeys> {
	translations: Translations<T>;
	isLoadingTranslations: boolean;
	translate: TranslateFunction;
}

const useTranslationsByTypedArray = <T extends TextKeys>(textKeys: T, partialResult?: boolean) =>
	useTranslationsBase(textKeys as unknown as string[], partialResult) as ReturnValue<T>;

export default useTranslationsByTypedArray;
